<template>
  <div>
    <el-dialog
      :center="false"
      title="绑定CA"
      width="500px"
      :visible.sync="visible"
      :show-close="false"
      style="text-align: left"
      :before-close="close"
      :close-on-click-modal="false"
    >
      <el-form label-position="top" :rules="caInfoRules" :model="caInfo" ref="caInfoRef">
        <el-row>
          <el-col :span="24">
            <el-form-item prop="caCode">
              <div style="display: flex">
                <el-input v-model="caInfo.caCode" auto-complete="off" :disabled="true"></el-input>
                <el-button type="primary" style="margin-top: 1px;margin-left: 2px" :size="size" @click="bindCA">绑定CA
                </el-button>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <span class="regTip">请绑定法人一证通数字证书，且此证书将作为主证书使用</span>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
    <el-button @click="close">取 消</el-button>
    <el-button type="primary" @click="btnOkSubmit">确 定</el-button>
  </span>
    </el-dialog>
    <el-dialog
      title="请输入密码"
      :visible.sync="passwordDlgVisible"
      width="500px"
      :show-close="false"
      @close="passowrd=''"
      :close-on-click-modal="false"
    >
      <el-input type="password" v-model="passowrd"></el-input>
      <span slot="footer" class="dialog-footer">
    <el-button @click="passwordDlgVisible=false">取 消</el-button>
    <el-button type="primary" @click="btnOkClick">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>

import {CA} from '@/utils/cert';

export default {
  name: 'DlgCA',
  components: {},
  props: ['formData'],
  data() {
    return {
      size: 'small',
      visible: false,
      passwordDlgVisible: false,
      passowrd: null,
      caInfo: {
        caCode: '',
      },
      caInfoRules: {
        caCode: [
          {required: true, message: '请绑定法人一证通数字证书', trigger: 'blur'},
        ],
      },
    };
  },
  mounted() {
  },
  methods: {
    bindCA() {
      this.CA = new CA();
      this.CA.initService().then((str) => {
        this.getCAInfo();
      }).catch(error => {
        this.$message.error('未检测到CA锁，请插入CA锁!');
      });
    },
    close: function() {//点击了取消
      this.visible = false;
    },
    btnOkSubmit: function() {//点击了确定
      this.$refs['caInfoRef'].validate(function(valid) {
        if (valid) {
          this.formData.name = this.caInfo.name;
          this.close();
        }
      }.bind(this));
    },
    getCAInfo: function() {
      this.passwordDlgVisible = true;
    },
    btnOkClick: function() {
      this.CA.getCertInfo(this.passowrd).then(obj => {
        if (this.formData.tyshxydm != obj['shxydm']) {
          this.$message.error('企业统一社会信用代码与变更企业统一社会信用代码不一致，不允许变更！');
          return;
        }
        this.caInfo['name'] = obj['cerUniversalName'];
        this.caInfo['caCode'] = obj['cerOID'];
        this.passwordDlgVisible = false;
      }).catch(e => {
        this.$message.error(e.message);
      });

    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Member/DlgCA.vue